export let ContentUserGroup = /*#__PURE__*/function (ContentUserGroup) {
  ContentUserGroup["ContentTechnician"] = "Content Technician";
  ContentUserGroup["ContentSpecialist"] = "Content Specialist";
  ContentUserGroup["ExternalContentTechnician"] = "External Content Specialist";
  ContentUserGroup["HiveAdmin"] = "Hive Admin";
  ContentUserGroup["HiveJunior"] = "Hive Junior";
  return ContentUserGroup;
}({});